import app from 'flarum/forum/app';
import on from './gate';
export const building = status => status === 'pending' || status === 'building';
// One request at a time; no timer survives removal or a terminal build state.
export default function pollLearn(slug, receive) {
  let stopped = false;
  let timer;
  const schedule = () => {
    if (!stopped) timer = setTimeout(tick, 15000);
  };
  const tick = () => {
    if (stopped || !on()) return;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/challenges/learn/' + encodeURIComponent(slug),
      errorHandler: () => {}
    }).then(r => {
      if (!stopped) {
        receive(r.data);
        if (building(r.data.status)) schedule();
      }
    }).catch(e => {
      if (e.status !== 403 && e.status !== 404) schedule();
    }).finally(() => {
      if (!stopped) m.redraw();
    });
  };
  schedule();
  return () => {
    stopped = true;
    clearTimeout(timer);
  };
}